import axios from 'axios'
import { toast } from 'react-toastify'
import { getToken, logout } from './Auth'

const axiosInstance = axios.create()

// ✅ Attach token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// ✅ Handle token errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    const data = response.data

    if (typeof data === 'string') {
      const msg = data.trim().toUpperCase()

      if (msg === 'TOKENREQUIRED') {
        toast.error('Token required. Please login.')
        setTimeout(() => {
          logout()
          window.location.href = '/'
        }, 2000)
        // return Promise.reject(msg)
      }

      if (msg === 'TOKENEXPIRED') {
        toast.error('Session expired. Please login again.')
        setTimeout(() => {
          logout()
          window.location.href = '/'
        }, 2000)
        // return Promise.reject(msg)
      }

      if (msg === 'INVALIDTOKEN') {
        toast.error('Invalid session. Please login again.')
        setTimeout(() => {
          logout()
          window.location.href = '/'
        }, 2000)
        // return Promise.reject(msg)
      }
    }

    return response
  },
  (error) => {
    toast.error('Server error')
    return Promise.reject(error)
  },
)

export default axiosInstance
